import type { PLVProduct } from '../types/plv.types';

export function calculateInitialQuantity(product: PLVProduct): number {
  if (!product.quantityPricePairs || product.quantityPricePairs.length === 0) return 1;
  const sortedPairs = [...product.quantityPricePairs].sort((a, b) => a.quantity - b.quantity);
  return sortedPairs[0].quantity;
}

export function generateQuantityOptions(product: PLVProduct, maxOptions: number = 10): number[] {
  if (!product.quantityPricePairs || product.quantityPricePairs.length === 0) return [1];
  const availableQuantities = [...product.quantityPricePairs]
    .map(pair => pair.quantity)
    .sort((a, b) => a - b);
  return availableQuantities.slice(0, maxOptions);
}

export function isValidQuantity(product: PLVProduct, quantity: number): boolean {
  if (!product.quantityPricePairs || product.quantityPricePairs.length === 0) return quantity > 0;
  return product.quantityPricePairs.some(pair => pair.quantity === quantity);
}

export function formatQuantity(quantity: number): string {
  return quantity.toLocaleString('fr-FR');
}

export function getQuantityTiers(product: PLVProduct): number[] {
  if (!product.quantityPricePairs || product.quantityPricePairs.length === 0) return [1];
  return product.quantityPricePairs.map(pair => pair.quantity).sort((a, b) => a - b);
}

export function getNextQuantityTier(product: PLVProduct, currentQuantity: number): number {
  const tiers = getQuantityTiers(product);
  const currentIndex = tiers.findIndex(tier => tier >= currentQuantity);
  if (currentIndex === -1) return tiers[tiers.length - 1];
  if (currentIndex < tiers.length - 1) return tiers[currentIndex + 1];
  return currentQuantity;
}

export function getPreviousQuantityTier(product: PLVProduct, currentQuantity: number): number {
  const tiers = getQuantityTiers(product);
  const currentIndex = tiers.findIndex(tier => tier >= currentQuantity);
  if (currentIndex === -1) return tiers[tiers.length - 1];
  if (currentIndex > 0) return tiers[currentIndex - 1];
  return 0;
}
